export const REDIRECT_AFTER_SIGN_URL = 'https://www.propdocs.com/signed';
